import repository from "../Repository";

export default {
  /**
   * 検索参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
   async list(screenId, payload) {
    return await repository.post(
      "lodine_pre_distribution_info",
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
